'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Hand = function Hand(_ref) {
  var angle = _ref.angle,
      name = _ref.name,
      length = _ref.length,
      oppositeLength = _ref.oppositeLength,
      width = _ref.width;

  if (length > 100) {
    throw new Error('Hand can\'t be longer than 100 (%).');
  }

  if (oppositeLength < 0 || oppositeLength > 100) {
    throw new Error('Opposite length of the hand must be between 0 and 100.');
  }

  if (oppositeLength > length) {
    throw new Error('Opposite side of the hand can\'t be longer than its main part.');
  }

  return _react2.default.createElement('div', {
    className: 'react-clock__hand react-clock__' + name + '-hand',
    style: {
      transform: 'rotate(' + angle + 'deg)'
    }
  }, _react2.default.createElement('div', {
    className: 'react-clock__hand__body react-clock__' + name + '-hand__body',
    style: {
      width: width + 'px',
      top: 50 - length / 2 + '%',
      bottom: 50 - oppositeLength / 2 + '%'
    }
  }));
};

Hand.defaultProps = {
  angle: 0,
  length: 100,
  oppositeLength: 10,
  width: 1
};
Hand.propTypes = {
  angle: _propTypes2.default.number,
  name: _propTypes2.default.string,
  length: _propTypes2.default.number,
  oppositeLength: _propTypes2.default.number,
  width: _propTypes2.default.number
};
exports.default = Hand;